<template>
<div class="card">

    <div class="card-header">
        <img class="card-img-top" :src="item.img_path" alt="Card image cap">
    </div>
    <div class="card-body">
        <h5 class="card-title">{{ item.title}}</h5>
        <div class="cont">{{item.spec}}
        </div>
    </div>
    <app-modal :item=item></app-modal>


</div>
</template>

<script>
import AppModal from "../components/AppModal.vue"

export default {
    props: ['item'],

    components: {
        AppModal
    }

}
</script>

<style scoped>
.card {
    max-width: 250px;
    min-width: 200px;
}

.card-header {
    height: 150px;
    background-color: #fff;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 0;

}

.card-header img {
    max-height: 100%;
}

.cont {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
}
</style>
